export function RoleManagementPage() {
  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-semibold">Role Management</h1>
      <p className="text-muted-foreground">Configure roles and permissions.</p>
    </div>
  );
}
